// extracted by mini-css-extract-plugin
module.exports = {"title":"screen-verify_3jKF2","description":"screen-verify_28HSr","footNotes":"screen-verify_1aiL9","security":"screen-verify_1F0Pf"};